/**
 * KRCL Admin entrypoint.
 *
 * Mounts the React tree, wires the urql client + auth context, and hands
 * off to the router. Everything below this is component code.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider as UrqlProvider } from "urql";

import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { createUrqlClient } from "./graphql/client";

import "./styles/index.css";

const urqlClient = createUrqlClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UrqlProvider value={urqlClient}>
          <App />
        </UrqlProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
